// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"caf8543e","568":"6cbc4220"}[chunkId] + ".chunk.js";
};